import React, { useState, useEffect } from 'react'

import Layout from '../Layout/Layout'
import { url, header } from "../Constent/Constant";

const CopyRights = () => {
    const [CopyRights, setCopyRights] = useState('')

    useEffect(() => {
        fetch(`${url}/page/viewpagedata`, {
            method: 'POST',
            body: JSON.stringify({
                name: "Copyright"
            }),
            headers: header
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setCopyRights(data.doc)
            })
    }, [])
    return (
        <Layout>
            {CopyRights && <div className='CR-container'>
                <h2 style={{color:'var(--primary)', fontSize:'35px', marginBottom:'2rem'}}>{CopyRights.section1heading1.content}</h2>
                <p>{CopyRights.section1paragraph1.content}</p>
                <h2>{CopyRights.section2heading1.content}</h2>
                <p>{CopyRights.section2paragraph1.content}</p>
            </div>}
        </Layout>
    )
}

export default CopyRights
